import Class from './chart-variable-pie';
import './chart-variable-pie@.vue';

export default Class;